<template>
  <div>
    <div v-if="$store.state.examList">
      <vue-good-table
        :line-numbers="true"
        :columns="columns"
        :rows="$store.state.examList"
        :search-options="{ enabled: true }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'code', type: 'desc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'page',
          perPage: 10,
        }"
      >
        <div slot="table-actions">
          <button
            class="btn btn-yellow"
            style="margin-right: 5px"
            @click="modalCreateExam = true"
          >
            +add
          </button>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'tools'">
            <CDropdown>
              <template #toggler>
                <CHeaderNavLink>
                  <button class="btn btn-warning">Tools</button>
                </CHeaderNavLink>
              </template>
              <CDropdownItem>
                <div
                  class="text-center"
                  style="width: 100%"
                  @click="getCourseData(props.row.course_id)"
                >
                  edit
                </div>
              </CDropdownItem>
            </CDropdown>
          </span>
          <span v-if="props.column.field == 'coursesList'">
            <div v-for="(course, n) in props.row.coursesList" :key="course.id">
              {{ n + 1 }}) {{ course.course_name }}
            </div>
          </span>

          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
      </vue-good-table>
    </div>
    <div v-else class="spinner-border text-secondary" role="status">
      <span class="sr-only">Loading...</span>
    </div>

    <!--MODAL CRAETE-------------------------------------------------->
    <form id="formCreateExam" v-on:submit.prevent="createExam" method="POST">
      <CModal
        :show.sync="modalCreateExam"
        :no-close-on-backdrop="true"
        :centered="true"
        title="Modal title 2"
        size="lg"
      >
        <CRow>
          <CCol lg="6">
            <label
              class="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-password"
            >
              รหัสผู้ใช้:
            </label>
            <input
              type="text"
              name="userId"
              class="form-control"
              v-model="userData.adminlogin_id"
              readonly
            />
          </CCol>
          <CCol lg="6">
            <div class="form-group">
              <label for="exampleFormControlFile1">ชื่อชุดแบบทดสอบ:</label>
              <input
                type="text"
                class="form-control"
                name="examName"
                required
              />
            </div>
          </CCol>
          <CCol lg="12">
            <SltCourseTest/>
          </CCol>
        </CRow>
        <template #header>
          <h6 class="modal-title">
            <h3 class="text-3xl font-semibold">สร้างชุดแบบทดสอบ</h3>
          </h6>
          <CButtonClose @click="modalCreateExam = false" class="text-white" />
        </template>
        <template #footer>
          <CButton @click="modalCreateExam = false" color="danger"
            >Discard</CButton
          >
          <span v-if="loadingState">loading...</span>
          <button type="submit" class="btn btn-success">Save</button>
        </template>
      </CModal>
    </form>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Datepicker from "vuejs-datepicker";
import SltCourseTest from "./SltCourseTest";

export default {
  components: {
    VueGoodTable,
    vSelect,
    Datepicker,
    SltCourseTest
  },
  data() {
    return {
      userData: this.$cookies.get("user"),
      columns: [
        {
          label: "#",
          field: "code",
          type: "number",
        },
        {
          label: "ชื่อชุดแบบทดสอบ",
          field: "label",
        },
        {
          label: "แบบทดสอบ",
          field: "coursesList",
          html: true,
          sortable: false,
        },
      ],
      modalCreateExam: false,
      loadingState:false
    };
  },
  mounted() {
    //FETCH EXAM DATA
    this.axios
      .get(
        this.$hostUrl + "php_action/examAPI2021.php?txtAction=getExamDropdown"
      )
      .then((response) => {
        //console.log(response.data.mainData);
        this.$store.commit("setExamList", response.data.mainData);
      });
  },
  methods: {
    createExam(event) {
      this.loadingState = true;
      const form = document.getElementById(event.target.id);
      const formData = new FormData(form);
      formData.append("txtAction", "createExam");
      formData.append("examCourses", JSON.stringify(this.$store.state.selectedCourseTest));
      this.axios
        .post(this.$hostUrl + "php_action/examAPI2021.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //console.log(response.data);
          this.loadingState = false;
          
          if(response.data.createState == "created"){
              location.reload();
          }
          else{
            alert(response.data.error);
          }
        

        });
        
    },
    courseList(rowObj) {
      let showStr = "";
      rowObj.coursesList.forEach((element) => {
        showStr = showStr + "<div>" + element.course_name.toString() + "</div>";
        console.log(showStr);
      });

      return "<div>hello</div>";
    },
    exampleCourseList(rowObj) {
      //let a = JSON.parse(rowObj.courses);

      return rowObj.courses[0].course_name.toString();
    },
  },
};
</script>
<style scoped>
.ui-input-text {
  border-color: transparent;
}
</style>
